<template>
  <div>
    <div class="fill-line">
      <div class="fill-label">专家姓名：</div>
      <div class="fill-cont">
        <el-input
          v-model="name"
          style="width: 210px"
          placeholder="请输入专家姓名"
          clearable
        ></el-input>
      </div>
    </div>
    <div class="fill-line">
      <div class="fill-label">专家邮箱：</div>
      <div class="fill-cont">
        <el-input
          v-model="mail"
          style="width: 210px"
          placeholder="请输入专家邮箱"
          clearable
        ></el-input>
      </div>
    </div>
    <div class="fill-line">
      <div class="fill-label">选择省份：</div>
      <div class="fill-cont">
        <el-select
          v-model="provValue"
          placeholder="请选择"
          style="width: 210px"
          @change="changeProv"
        >
          <el-option
            v-for="item in provList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="fill-line">
      <div class="fill-label">医院名称：</div>
      <div class="fill-cont">
        <el-input
          v-model="hospitalName"
          style="width: 210px"
          placeholder="请输入医院名称"
          clearable
        ></el-input>
      </div>
    </div>
  </div>
</template>
<script>
import { fetchLocation } from "@/api/city";
export default {
  name: "PccmFill",
  data() {
    return {
      // 省份列表
      provList: [],
      name: "",
      mail: "",
      provValue: "",
      hospitalName: "",
    };
  },
  mounted() {
    fetchLocation({
      parent_code: "0",
    }).then((res) => {
      const { code, data } = res;
      if (code === 0) {
        this.provList = data.reduce((list, el) => {
          list.push({
            label: el.name,
            value: el.name,
          });
          return list;
        }, []);
      }
    });
  },
  computed: {},
  methods: {
    changeProv(val) {
      console.log(val, "changeProv");
    },
    check() {
      const { name, mail, hospitalName, provValue } = this;
      if (!name) {
        this.$message({
          message: "请输入专家姓名",
          type: "error",
        });
        return null;
      }
      if (!mail) {
        this.$message({
          message: "请输入专家邮箱",
          type: "error",
        });
        return null;
      }
      if (!provValue) {
        this.$message({
          message: "请选择省份",
          type: "error",
        });
        return null;
      }
      if (!hospitalName) {
        this.$message({
          message: "请输入医院名称",
          type: "error",
        });
        return null;
      }
      return {
        name,
        email: mail,
        province: provValue,
        hospital: hospitalName,
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.fill-line {
  display: flex;
  align-items: center;
  height: 46px;
  margin: 0 0 18px;
}
.fill-label {
  width: 100px;
  color: #272222;
  font-size: 14px;
}
</style>
